var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"tavolos-hotelintel"}},[_c('div',{staticClass:"tavolos-hotelintel-header"},[_c('div',{staticClass:"tavolos-hotelintel-logo"},[_c('img',{attrs:{"src":_vm.logo_src}})])]),_vm._v(" "),_c('div',{staticClass:"tavolos-hotelintel-content"},[_c('transition',{attrs:{"name":"tavolos-slide-right-fade","mode":"out-in"}},[_c('Book',{attrs:{"restaurant_id":_vm.restaurant_id,"publisher_id":_vm.publisher_id}})],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c7223ca","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HotelIntel.vue
// module id = 64
// module chunks = 0